/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import * as React from 'react';
import { MenuItem, Select } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { func, object } from 'prop-types';

const styles = (theme) => ({
  disable: {
      color: theme.palette.colorNeutral70,
  },
  selectCancelReason: {
    '& .mbp-account-MuiSelect-icon': {
      color: theme.palette.colorPrimaryAccountCtaButton,
    },
  },
});

const CancelReasonListMenu = ({ setCancelReason, classes }) => {
  const [reason, setReason] = React.useState('');

  const handleChange = (event) => {
    setReason(event.target.value);
    setCancelReason(event.target.value);
  };

  const options = [
    'Order created by mistake',
    'Duplicate order',
    'Product will not arrive on time',
    'Need to update recipient/delivery information',
    'Found another gift',
    'Change my mind',
    'Other',
  ];

  return (
    <div>
        <Select
            labelId="demo-simple-select-label"
            id="demo-simple-select"
            value={reason}
            variant="outlined"
            onChange={handleChange}
            className={classes.selectCancelReason}
            fullWidth
            displayEmpty
            renderValue={(selected) => {
                if (selected.length === 0) {
                  return <div className={classes.disable}>Cancel Reason</div>;
                }
                return selected;
              }}
        >
        <MenuItem disabled value="">
            <li>Cancel Reason</li>
        </MenuItem>
        {options.map((option) => (
            <MenuItem value={option} key={option}>
                {option}
            </MenuItem>
            ))}
        </Select>
    </div>
  );
}

CancelReasonListMenu.propTypes = {
  classes: object.isRequired,
  setCancelReason: func.isRequired
};

export default withStyles(styles)(CancelReasonListMenu);

